import axios from 'axios';
import { getValidToken } from '../utils/tokenUtils';

const SUPERVISOR_BASE_URL = process.env.REACT_APP_SERVICE_SUPERVISOR_URL !== undefined
  ? process.env.REACT_APP_SERVICE_SUPERVISOR_URL
  : '';

const supervisorApi = axios.create({
  baseURL: SUPERVISOR_BASE_URL,
  timeout: Number(process.env.REACT_APP_SERVICE_SUPERVISOR_TIMEOUT_MS || 12000),
  headers: {
    'Content-Type': 'application/json',
  },
});

supervisorApi.interceptors.request.use((config) => {
  const token = getValidToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

const STATUS_LABELS = {
  active: 'Работает',
  inactive: 'Остановлен',
  failed: 'Ошибка',
  activating: 'Запускается',
  deactivating: 'Останавливается',
  'not-found': 'Не установлен',
  unknown: 'Неизвестно',
};

export const getSystemServiceStatusLabel = (status) => (
  STATUS_LABELS[status] || status || '—'
);

export const getSystemServiceStatusColor = (status) => {
  if (status === 'active') return 'success';
  if (status === 'activating' || status === 'deactivating') return 'processing';
  if (status === 'inactive' || status === 'failed' || status === 'not-found') return 'error';
  return 'default';
};

export async function fetchSystemServicesStatus(includeOptional = true) {
  const response = await supervisorApi.get('/api/v1/system-services/status', {
    params: { include_optional: includeOptional },
  });
  return response.data;
}

export async function restartSystemService(serviceId) {
  const response = await supervisorApi.post(
    `/api/v1/system-services/${encodeURIComponent(serviceId)}/restart`,
  );
  return response.data;
}

export async function checkServiceSupervisorHealth() {
  const response = await supervisorApi.get('/health', { timeout: 5000 });
  return response.data;
}
